<template>
  <div class="form-check autozoom" title="AutoZoom to Selected Geography">
    <input v-model="autoZoom" class="mapboxgl-ctrl-icon form-check-input" type="checkbox" checked="checked" value="">
  </div>
</template>

<script>
export default {
  name: 'AutoZoom',
  data: function () {
    return {
      autoZoom: true,
    }
  },
  watch: {
    autoZoom: function () {
      this.$emit("autoZoom", this.autoZoom)
    },
  },
}
</script>

<style scoped>
.form-check {
  background-color: white
}

.form-check input {
  margin-top: .2rem;
  margin-left: -1.01rem;
}

.autozoom {
  background-image: url('images/noun_1501805_cc.svg');
  background-repeat: no-repeat;
  background-size: 42px;
  background-position: -7px -7px;
  width: 29px;
  height: 29px;
  padding: 2px;
  border-radius: 4px;
}

div.autozoom input {
  margin: 6px;
}
</style>
